import "./SectionFiveSliderCard.css";

import React from "react";

import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

export const SectionFiveSliderCard = ({ name, position, text }) => {
  return (
    <div className="section-five-slider-content">
      <p className="section-five-slider-content-name">{name}</p>
      <p className="section-five-slider-content-position">{position}</p>
      <p className="section-five-slider-content-text">{text}</p>
      <FormatQuoteIcon sx={{ fontSize: "6rem", mb: "1rem" }} />
    </div>
  );
};
